import {FormBuilderAnswerableTextField, FormBuilderQuestion} from "@/types";
import {ExclamationCircleIcon} from '@heroicons/react/20/solid'
import {useState} from "react";

interface Props {
    question: FormBuilderQuestion,
    hasError: boolean
}

export default function AnswerableTextField<T extends { answerable: FormBuilderAnswerableTextField }>({
                                                                                                          question,
                                                                                                          data,
                                                                                                          setData,
                                                                                                          hasError,
                                                                                                          settings
                                                                                                      }: Props) {

    // check if the default is null and convert it to a string because React doesnt like null
    const value = !data[question.id] ? "" : data[question.id];

    if ("is_multiline" in question.answerable && question.answerable.is_multiline) {
        return (
            <div className="relative mt-1">
        <textarea
            minLength={question.answerable.min_length}
            maxLength={question.answerable.max_length}
            required={"is_required" in question.answerable ? question.answerable.is_required : false}
            rows={question.answerable.max_lines ?? 2}
            className={`rounded shadow-sm block w-full disabled:opacity-50 disabled:cursor-not-allowed ${hasError
                ? 'border-red-300 pr-10 text-red-900 placeholder-red-300 focus:border-red-500 focus:outline-none focus:ring-red-500 disabled:opacity-50 disabled:cursor-not-allowed'
                : `border-gray-100 focus:border-[${settings.primaryColour}] focus:ring-[${settings.primaryColour}] `}`}
            placeholder={"placeholder_text" in question.answerable ? question.answerable.placeholder_text : ''}
            id={`${question.id}-target`}
            value={value}
            onChange={(e) => setData(question.id, e.target.value)}
        />
                {(hasError) ? (errorBadge()) : (<></>)}
            </div>
        );
    } else {
        if (question.answerable.type == 'tel') {
            return <AnswerableTelephone question={question} setData={setData} hasError={hasError} settings={settings} value={value}/>
        } else {
            return (
                <div className="relative mt-1">
                    {question.answerable.type == 'currency' ? (
                        <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                            <span className="text-gray-600 sm:text-sm">£</span>
                        </div>) : <></>}
                    <input
                        type={"type" in question.answerable && !["currency"].includes(question.answerable.type) ? question.answerable.type : "text"}
                        minLength={"min_length" in question.answerable ? question.answerable.min_length : 0}
                        maxLength={"max_length" in question.answerable && question.answerable.max_length > 0 ? question.answerable.max_length : 524_288}
                        required={"is_required" in question.answerable ? question.answerable.is_required : false}
                        className={` rounded shadow-sm block w-full disabled:opacity-50 disabled:cursor-not-allowed ${question.answerable.type == 'currency' ? 'pl-7 pr-12' : ''} ${question.answerable.type == 'tel' ? 'pl-10' : ''} ${hasError
                            ? 'border-red-300 pr-10 text-red-900 placeholder-red-300 focus:border-red-500 focus:outline-none focus:ring-red-500'
                            : `border-gray-100 focus:border-[${settings.primaryColour}] focus:ring-[${settings.primaryColour}] `}`}
                        placeholder={"placeholder_text" in question.answerable ? question.answerable.placeholder_text : ''}
                        aria-describedby={`${question.id}-description`}
                        id={`${question.id}-target`}
                        value={value}
                        onChange={(e) => {
                            let newValue = e.target.value
                            if (question.answerable.type == 'currency') {
                                console.log('trimming type')
                                newValue = newValue.replace(/[^\d\.,]+/g, '')
                            }
                            setData(question.id, newValue)
                        }}/>
                    {(hasError) ? (errorBadge()) : (<></>)}
                    {question.answerable.type == 'currency' ? (
                        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-3 bg-gray-50 border border-gray-100 rounded-r">
                            <span className="text-gray-600 sm:text-sm" id="price-currency">GBP</span>
                        </div>) : <></>}
                </div>
            );

        }
    }

}

function errorBadge() {
    return (<div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
        <ExclamationCircleIcon className="h-5 w-5 text-red-500" aria-hidden="true"/>
    </div>)
}

function AnswerableTelephone({question, setData, hasError, settings, value}: Props) {
    const [countryCode, setCountryCode] = useState<string>('+44')
    return (
        <div className={`relative mt-1`}>
            <div className="absolute inset-y-0 left-0 flex items-center">
                <label htmlFor="country" className="sr-only">
                    Country
                </label>
                <select
                    id={`countryCode${question.id}`}
                    value={countryCode}
                    onChange={(e) => {
                        // We need to remove the old country code and add the new one
                        setData(question.id, `${e.target.value}` + `${value.replace(countryCode, '')}`)
                        setCountryCode(e.target.value)
                    }}
                    autoComplete="country"
                    className="h-full rounded border-0 bg-transparent py-0 pl-3 pr-7 text-gray-600 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-600"
                >
                    <option value={'+44'}>+44</option>
                    <option value={'+353'}>+353</option>
                </select>
            </div>
            <input
                type="text"
                name="phone-number"
                id="phone-number"
                className={`rounded shadow-sm block w-full pl-20 ${hasError
                    ? 'border-red-300 pr-10 text-red-900 placeholder-red-300 focus:border-red-500 focus:outline-none focus:ring-red-500'
                    : `border-[#bbbdc1] focus:border-[${settings.primaryColour}] focus:ring-[${settings.primaryColour}] `}
                `}
                value={value.replace(countryCode, '')}
                placeholder={`1952 123456`}
                pattern="[0-9]{8-11}"
                onChange={(e) => {
                    let newValue = e.target.value
                    newValue = `${newValue.replace(/\D/g, '')}`;
                    setData(question.id, `${countryCode}` + `${newValue}`)
                }}/>
        </div>
    );
}
